import { connect } from 'react-redux'
import Sidebar from '../../../../common/containers/Sidebar'
import Card from '../../../../common/containers/Card'
import { Route, Routes } from 'react-router'
import UserList from './UserList'
import UserEdit from './UserEdit'
import { useState } from 'react'
import UserCompany from './UserCompany'
import UserRegion from './UserRegion'

let UserPage = () => {
    const [pageAttr, setPageAttr] = useState({})

    return (
        <Sidebar>
            <Card {...pageAttr}>
                <Routes>
                    <Route path='/regions/:userId' element={<UserRegion setPageAttr={setPageAttr} />} />
                    <Route path='/companies/:userId' element={<UserCompany setPageAttr={setPageAttr} />} />
                    <Route path='/edit/:id' element={<UserEdit setPageAttr={setPageAttr} />} />
                    <Route path='/add' element={<UserEdit setPageAttr={setPageAttr} />} />
                    <Route path='/' element={<UserList setPageAttr={setPageAttr} />} />
                </Routes>
            </Card>
        </Sidebar>
    )
}

export default connect()(UserPage)